export enum SPINNER_ELEMENT {
    ARROW = 'arrow',
    HUBCAP = 'hubcap',
    WHEEL = 'wheel'
}

export enum SPINNER_ANIMATION {
    SPIN_TEASE = 'spin-tease',
    SPINNING = 'spinning',
    SPIN_FINAL = 'spin-final'
}
